import LogRocket from 'logrocket'

// Route-operation LogRocket breadcrumbs, mirroring `masterSequenceTelemetry` for the executor's
// side of the board. Labels and counts only — a backend message can name an account.
const NAMESPACE = 'route-ops'

export const logRouteOpEvent = (event: string, data: Record<string, unknown>): void => {
  LogRocket.log(`[${NAMESPACE}] ${event}`, data)
}
